// voiceRecognition.js
let recognition;
let callback = () => {};

export function setCallback(cb) {
  callback = cb;
}

export function startVoiceRecognition(onResultCallback) {
  if (!recognition) {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    recognition = new SpeechRecognition();
    recognition.lang = 'es-ES';
    recognition.interimResults = false;
    recognition.continuous = true;

    recognition.onresult = (event) => {
      const transcript = event.results[event.results.length - 1][0].transcript;
      callback(transcript);
    };

    recognition.onerror = (e) => console.error("Recognition error:", e);
    recognition.onend = () => recognition.start(); // Reinicia automáticamente
  }

  setCallback(onResultCallback);
  recognition.start();
}

export function stopVoiceRecognition() {
  if (recognition) {
    recognition.onend = null; // Previene reinicio automático
    recognition.stop();
  }
}
